<button class="btn btn-outline-primary d-md-none" (click)="showSearchForMobile()">
  <fa-icon icon="search"></fa-icon>
</button>

<div [(ngbCollapse)]="hideMobileSearch" [animation]="false" class="mobile-search-form" (click)="hideSearchForMobile()">
  <div (click)="$event.stopImmediatePropagation()" class="position-relative">
    <fa-icon icon="arrow-left" (click)="hideSearchForMobile()"></fa-icon>
    <form ngNoForm (submit)="doSearch($event); hideSearchForMobile()">
      <input [(ngModel)]="searchValue" type="search" #mobilesearch placeholder="{{helper}}">
    </form>
    <div class="clear-search-icon" (click)="searchValue = ''">
      <fa-icon icon="times"></fa-icon>
    </div>
  </div>
</div>
